import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const projects = [
  { id:1,  cat:'web',     icon:'🛒', title:'RetailPlus E-Commerce',    tech:['React','Node.js','MongoDB'],    desc:'Full-featured online store with custom admin panel, inventory management, and Razorpay integration. 3x sales increase in 6 months.' },
  { id:2,  cat:'mobile',  icon:'🏥', title:'HealthTrack Mobile App',    tech:['Flutter','Firebase'],           desc:'Patient management app for clinics with appointment booking, prescription history, and real-time doctor chat.' },
  { id:3,  cat:'web',     icon:'🏗️', title:'ConstructoERP Web Portal',  tech:['Laravel','Vue.js','MySQL'],     desc:'Complete ERP for a construction company — project tracking, material procurement, payroll, and reporting.' },
  { id:4,  cat:'design',  icon:'🎨', title:'BrandIdentity Relaunch',    tech:['Figma','Adobe XD'],            desc:'Complete rebranding for a Pune-based FMCG company — logo, brand book, packaging design, and website mockups.' },
  { id:5,  cat:'web',     icon:'🎓', title:'EduLearn LMS Platform',     tech:['React','Django','PostgreSQL'],  desc:'Learning management system with video courses, quizzes, certificates, and a live virtual classroom.' },
  { id:6,  cat:'mobile',  icon:'🍕', title:'FoodieGo Delivery App',     tech:['React Native','Node.js'],       desc:'Food delivery app for a restaurant chain — customer app, restaurant dashboard, and rider tracking.' },
  { id:7,  cat:'marketing',icon:'📈',title:'GrowthX SEO Campaign',      tech:['SEO','Google Ads'],            desc:'Organic traffic grew from 2K to 28K monthly visitors in 8 months for a B2B SaaS product.' },
  { id:8,  cat:'web',     icon:'🏨', title:'HotelNest Booking System',  tech:['Next.js','Stripe','Prisma'],   desc:'Hotel booking platform with real-time availability, multi-property management, and dynamic pricing.' },
  { id:9,  cat:'ai',      icon:'🤖', title:'ChatBot for FinTech',       tech:['Python','OpenAI','FastAPI'],   desc:'AI-powered customer service bot handling 80% of support queries automatically, integrated with CRM.' },
];

const filters = ['All','web','mobile','design','marketing','ai'];
const filterLabels = { All:'All', web:'Web', mobile:'Mobile', design:'Design', marketing:'Marketing', ai:'AI & ML' };

export default function Portfolio() {
  const [active, setActive] = useState('All');
  const visible = active === 'All' ? projects : projects.filter(p => p.cat === active);

  return (
    <main className="vt-page">

      {/* Hero */}
      <section className="vt-page-hero vt-page-hero--portfolio">
        <div className="vt-page-hero__overlay" />
        <div className="vt-container vt-page-hero__content">
          <span className="vt-page-hero__eyebrow">Our Work</span>
          <h1 className="vt-page-hero__title">Projects That Speak For Themselves</h1>
          <p className="vt-page-hero__sub">Real solutions for real businesses — browse our recent work across industries.</p>
        </div>
      </section>

      {/* Portfolio */}
      <section className="vt-section">
        <div className="vt-container">

          {/* Filter tabs */}
          <div className="vt-portfolio-filters">
            {filters.map(f => (
              <button
                key={f}
                className={'vt-portfolio-filter' + (active === f ? ' active' : '')}
                onClick={() => setActive(f)}
              >{filterLabels[f]}</button>
            ))}
          </div>

          <div className="vt-portfolio-grid">
            {visible.map(p => (
              <div key={p.id} className="vt-portfolio-card">
                <div className="vt-portfolio-card__icon">{p.icon}</div>
                <div className="vt-portfolio-card__cat">{filterLabels[p.cat]}</div>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
                <div className="vt-portfolio-card__tech">
                  {p.tech.map(t => <span key={t} className="vt-tech-tag">{t}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="vt-cta-banner">
        <div className="vt-container vt-cta-banner__inner">
          <div>
            <h2>Have a Project in Mind?</h2>
            <p>Let us build your next success story together.</p>
          </div>
          <div className="vt-cta-banner__actions">
            <Link to="/contact" className="vt-btn vt-btn--white">Start Your Project</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
